// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imagefield {\n  background-color: #F2F2F2;\n  border-radius: 6px;\n}\n.imagefield img {\n  max-width: 230px;\n  margin: 20px;\n}\n.imagefield .button {\n  margin-top: 18%;\n}\n.managedby {\n  font-size: 12px;\n  margin: 12.5px;\n}\np.artistname {\n  margin: 12.5px;\n}", ""]);
// Exports
module.exports = exports;
